var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-tool"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.addFake}},[_vm._v("添加")]),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.removeFake}},[_vm._v("移除")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }